// extracted by extract-css-chunks-webpack-plugin
module.exports = {"main":"main_aBuY1"};